import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { TStore } from '@/apis/typings'
import { getAllStores } from '@/pages/app/management/service'
import { getProjectApp } from '@/shared/tools'

type State = {
  stores: TStore[]
  loading: boolean
  shouldCreateStore?: boolean
  currentStore: TStore | null
  error?: string | null

  setCurrentStore: (store: TStore) => void
  refreshStores: () => Promise<void>

  init: () => void
}

const storeKey = 'CURRENT_STORE'

const useManagementStore = create<State>()(
  devtools(
    immer((set, get) => ({
      stores: [],
      loading: true,
      currentStore: null,
      error: null,
      shouldCreateStore: false,
      init: () => {
        set((state) => {
          state.loading = true
        })
        get().refreshStores()
      },
      setCurrentStore: (store) => {
        localStorage.setItem(storeKey, JSON.stringify(store))

        set((state) => {
          console.log('currentStore2--?', store)

          state.currentStore = store
        })
      },

      refreshStores: async () => {
        try {
          const appid = getProjectApp()?.appid || ''
          const res = await getAllStores({ appid })
          if (!res.error) {
            set((state) => {
              state.loading = false
              state.stores = res.data
              state.shouldCreateStore = res.data?.length <= 0

              if (res.data?.length) {
                const currentStore = localStorage.getItem(storeKey)
                  ? JSON.parse(localStorage.getItem(storeKey) || '{}')
                  : res.data[0]
                state.currentStore = currentStore
                localStorage.setItem(storeKey, JSON.stringify(currentStore))
              }
            })
          } else {
            set((state) => {
              state.loading = false
              state.error = res.error
            })
          }
        } catch (error) {
          console.log('error-->', error)
          set((state) => {
            state.loading = false
            state.error = error?.toString() || '获取商店列表失败'
          })
        }
      },
    })),
  ),
)

export { useManagementStore }
